import React from 'react';

import css from './Footer.module.css';

const Footer = () => (
    <footer className={css.Footer}>
        <p>© Copyright - Aquavital | <a href = "mailto: aquavital@net.hr">aquavital@net.hr</a></p>
    </footer>
);

export default Footer;